import { tenantRegistry } from '@/config/app'

import { getTenantOverride } from './useTenantOverride'

/**
 * Composable для определения текущего тенанта
 * Определяет тенанта по поддомену или переменной окружения
 *
 * TEMPORARY: Также поддерживает переопределение через localStorage для тестирования
 * @see src/features/locale/TENANT_SWITCHER_README.md - инструкции по откату и удалению
 */
export function useTenant() {
  const getTenantId = (): string => {
    /**
     * Для отладки тенанта в режиме разработки, используем переопределение из localStorage
     */
    const overrideTenant = getTenantOverride()
    const isTenantDebugEnabled = import.meta.env.VITE_TENANT_DEBUG_ENABLED === 'true'
    if (isTenantDebugEnabled && overrideTenant) {
      return overrideTenant
    }

    // Проверяем переменную окружения для разработки
    const envTenantId = import.meta.env.VITE_TENANT_ID
    if (envTenantId) {
      return envTenantId
    }

    // Определяем по поддомену
    // if (typeof window !== 'undefined') {
    //   const hostname = window.location.hostname

    //   // Для localhost или IP-адресов используем дефолтного тенанта
    //   if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    //     return 'uplatform'
    //   }

    //   // Извлекаем поддомен (первая часть домена)
    //   const parts = hostname.split('.')
    //   if (parts.length >= 2) {
    //     return parts[1]
    //   }
    //   return parts[0]
    // }

    // Дефолтный тенант
    return 'uplatform'
  }

  // Кэшируем результат
  const tenantId = getTenantId()
  const tenantName = computed(() => tenantRegistry[tenantId].companyName)

  return {
    tenantId,
    tenantName,
  }
}
